<div class='container'>
    <div class='mb-3 pt-3'>
        <div class='h1'>Find Sensor History</div>
        <div class="flex-grow-1 fs-4 lh-base mb-md-3" style="margin-top: 24px;margin-bottom: 24px;">
            Append a single serial code and proceed.<br>
            This will search for related activities with this serial code and return them along with some information.<br><br>
        </div>
        <div class="d-flex flex-row align-items-center">
            <app-text-search class="flex-grow-1"
                             [value]='searchValue'
                             [searchHint]='searchHint'
                             [minLength]='minLength'
                             (submitEvent)='onSubmit()'
                             (valueChange)='onValueChanged($event)'
            >
            </app-text-search>
            <button class="m-3" color="primary" mat-raised-button type='submit'
                    [disabled]='!canSearch()'
                    (click)="onSubmit()">Search
            </button>
        </div>

        <div class="d-flex flex-column my-lg-5 view-surrounding-logs" *ngIf="this.shouldShowRelatedEmails()">
            <h3 class = "fs-5 lh-base mb-md-3">
                Select an email to view activity history only related to the selected email.</h3>
            <mat-chip-list *ngIf="this.shouldShowRelatedEmails">
                <mat-chip class="tag fs-6 p-2 mx-md-3" *ngFor="let email of this.relatedEmailsArray"
                      [selected]="email === this.filterResultsWithEmail"
                      (click)="this.onEmailToFilterResultsClicked(email)">
                    {{email}}
                </mat-chip>
            </mat-chip-list>
        </div>
    </div>
    <app-generic-admin-report-table
        [filter]='filter'
        [columnData]='columns'
        [loadingState]='loadingState'
        [dataSource]='showingDataSource'
        [viewModel]='viewModel'
        (actionButtonClick)="onDownloadRawDataCsvPressed($event)"
        modelLabel='Total Activities'
        searchLabel='Search Sensor Production Logs'>

    </app-generic-admin-report-table>
</div>
